import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { loadDriverOnboarding } from "../services/driverOnboardingService";
import "../components/DriverOnboarding.css";

const labels = {
  SUBMITTED: ["Cadastro enviado", "Sua documentação está na fila de análise da Zuno."],
  CHANGES_REQUIRED: ["Precisamos de um ajuste", "Revise os pontos indicados e envie novamente."],
  COMPLETED: ["Cadastro aprovado", "Sua conta está pronta para operar."],
};

export default function DriverApplicationStatus() {
  const navigate = useNavigate();
  const [state, setState] = useState(null);
  useEffect(() => {
    let active = true;
    loadDriverOnboarding().then((data) => active && setState(data));
    return () => { active = false; };
  }, []);
  const status = state?.draft?.status || "SUBMITTED";
  const [title, description] = labels[status] || labels.SUBMITTED;
  return <main className="driver-onboarding-shell">
    <section className="driver-onboarding-card status-card">
      <div className="driver-brand-mark">Z</div>
      <p className="driver-eyebrow">ZUNO MOTORISTA</p>
      <h1>{title}</h1><p>{description}</p>
      <div className="driver-status-list">
        <span>Identidade <strong>{state?.kyc?.status || "NÃO INICIADA"}</strong></span>
        <span>CNH <strong>{state?.draft?.cnhStatus || "PENDENTE"}</strong></span>
        <span>Veículo <strong>{state?.draft?.vehicleStatus || "PENDENTE"}</strong></span>
      </div>
      {state?.draft?.reviewReason && <div className="driver-alert">{state.draft.reviewReason}</div>}
      {status === "CHANGES_REQUIRED" && <button className="driver-primary" onClick={() => navigate("/cadastro-motorista")}>Corrigir cadastro</button>}
      {status === "COMPLETED" && <button className="driver-primary" onClick={() => navigate("/driver-home")}>Entrar no app</button>}
      <button className="driver-secondary" onClick={async () => { await signOut(auth); navigate("/login"); }}>Sair</button>
    </section>
  </main>;
}
